/* Straw & Sol — scroll reveal robuste (IntersectionObserver + révélation immédiate above-fold) */
(function () {
  function inView(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h * 0.96 && r.bottom > 0;
  }
  function reveal(el) { el.classList.add('ss-in'); }
  function init() {
    var els = [].slice.call(document.querySelectorAll('.ss-reveal:not(.ss-in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(reveal); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { if (inView(e)) { reveal(e); } else { io.observe(e); } });
    // filet de sécurité : rien ne reste caché si déjà visible
    setTimeout(function () {
      document.querySelectorAll('.ss-reveal:not(.ss-in)').forEach(function (e) { if (inView(e)) reveal(e); });
    }, 1400);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
